import { useEffect, useState, useRef } from "react";

// ═══════════════════════════════════════════════════════════════
// ICONS
// ═══════════════════════════════════════════════════════════════
function Ico({ d, size = 20, sw = 1.8, style = {}, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
      style={style} className={className}>
      {(Array.isArray(d) ? d : [d]).map((p, i) => <path key={i} d={p} />)}
    </svg>
  );
}
const IPhone    = p => <Ico {...p} d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 6.06 6.06l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />;
const IMail     = p => <Ico {...p} d={["M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z","M22 6l-10 7L2 6"]} />;
const IMenu     = p => <Ico {...p} d={["M3 12h18","M3 6h18","M3 18h18"]} />;
const IClose    = p => <Ico {...p} d={["M18 6L6 18","M6 6l12 12"]} />;
const IPin      = p => <Ico {...p} d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />;
const IArrowR   = p => <Ico {...p} d={["M5 12h14","M12 5l7 7-7 7"]} />;
const IArrowUR  = p => <Ico {...p} d={["M7 17L17 7","M7 7h10v10"]} />;
const IShield   = p => <Ico {...p} d={["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z","M9 12l2 2 4-4"]} />;
const IHammer   = p => <Ico {...p} d={["M15 12l-8.5 8.5c-.83.83-2.17.83-3 0a2.12 2.12 0 0 1 0-3L12 9","M17.64 15L22 10.64","M20.35 6.35L17.64 9.06A1.5 1.5 0 0 1 15.5 7L18.22 4.28a1 1 0 0 1 1.41 0l.72.72a1 1 0 0 1 0 1.35z"]} />;
const IClock    = p => <Ico {...p} d={["M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z","M12 6v6l4 2"]} />;
const ISearch   = p => <Ico {...p} d={["M21 21l-4.35-4.35","M17 11A6 6 0 1 0 5 11a6 6 0 0 0 12 0z"]} />;
const IUser     = p => <Ico {...p} d={["M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2","M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"]} />;
const IWrench   = p => <Ico {...p} d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />;
const ILayers   = p => <Ico {...p} d={["M12 2L2 7l10 5 10-5-10-5z","M2 17l10 5 10-5","M2 12l10 5 10-5"]} />;
const IThermo   = p => <Ico {...p} d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />;
const IMtn      = p => <Ico {...p} d="M3 20l7-12 4 6.5 2.5-3 4.5 8.5H3z" />;
const ITruck    = p => <Ico {...p} d={["M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3","M9 17h6","M13 17h3a2 2 0 0 0 2-2v-4l-3-4h-2","M7 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4z","M17 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"]} />;
const IScissors = p => <Ico {...p} d={["M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","M6 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","M20 4L8.12 15.88","M14.47 14.48L20 20","M8.12 8.12L12 12"]} />;
const ITree     = p => <Ico {...p} d={["M17 14l3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3A1 1 0 0 1 15.2 9H15l3 3.3a1 1 0 0 1-.7 1.7H17z","M12 22v-5"]} />;
const IDrop     = p => <Ico {...p} d={["M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z","M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"]} />;
const ISprout   = p => <Ico {...p} d={["M7 20h10","M10 20c5.5-2.5.8-6.4 3-10","M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z","M14.1 6a7 7 0 0 1 .8 4.7c1.9-.1 3.3-.6 4.3-1.7 1-1 1.6-2.7 1.8-5.4-2.7.1-4.9 1-6.9 2.4z"]} />;
const IPaint    = p => <Ico {...p} d={["M3 21v-2a4 4 0 0 1 4-4h14","M7 9h2a2 2 0 0 1 0 4H7v-4z","M7 9V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1"]} />;
const ICheck    = p => <Ico {...p} d="M20 6L9 17l-5-5" />;
const IEdit     = p => <Ico {...p} d={["M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7","M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"]} />;
const IImg      = p => <Ico {...p} d={["M21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3l2-3h4l2 3h3a2 2 0 0 1 2 2z","M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"]} />;
const ILock     = p => <Ico {...p} d={["M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z","M7 11V7a5 5 0 0 1 10 0v4"]} />;
const ILogout   = p => <Ico {...p} d={["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4","M16 17l5-5-5-5","M21 12H9"]} />;
const IEye      = p => <Ico {...p} d={["M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z","M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"]} />;
const IPlus     = p => <Ico {...p} d={["M12 5v14","M5 12h14"]} />;
const ITrash    = p => <Ico {...p} d={["M3 6h18","M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6","M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"]} />;
const ISave     = p => <Ico {...p} d={["M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z","M17 21v-8H7v8","M7 3v5h8"]} />;

// ═══════════════════════════════════════════════════════════════
// DEFAULT CONTENT
// ═══════════════════════════════════════════════════════════════
const DEFAULT_CONTENT = {
  phone: "+36 20 542 0090",
  email: "kissmasterkft@gmail.com",
  contact_name: "Kiss Márton",
  region: "Békés megye és vonzáskörzete",
  hero_title_1: "Ön pihen,",
  hero_title_2: "mi gondoskodunk",
  hero_title_3: "róla.",
  hero_desc: "Szeretné, ha ingatlana egész évben rendezett, karbantartott és értékálló maradna? Vállaljuk nyaralók, hétvégi házak és üdülők teljes körű karbantartását és felújítását Békés megyében és vonzáskörzetében.",
  experience: "10 év építőipari tapasztalat",
  why_title_1: "Egy kézben.",
  why_title_2: "Profi csapattól.",
  why_desc: "Ingatlana értékét hosszú távon megőrizzük, és rendezett környezetet biztosítunk Önnek egész évben.",
};

const DEFAULT_PILLARS = [
  { title: "10 év tapasztalat",     desc: "A cégünk új, de szakmai és kivitelezői hátterünk évtizedes múltra tekint vissza." },
  { title: "Megbízható kivitelezés", desc: "Precíz, tiszta és pontos munkavégzés, kizárólag minőségi anyagok felhasználásával." },
  { title: "Rendszeres vagy eseti",  desc: "Igény szerint folyamatos éves karbantartást vagy egyszeri felújítási munkákat is vállalunk." },
  { title: "Ingyenes felmérés",      desc: "Minden munkára teljesen díjmentes helyszíni felmérést és egyedi árajánlatot adunk." },
];

const DEFAULT_SVC = [
  {
    key: "construction",
    title: "Építőipar és Felújítás",
    subtitle: "Belső és külső munkálatok",
    items: ["Tereprendezés, alapozás","Bontás és sittszállítás","Festés, glettelés, belső munkák","Nemesvakolat és homlokzat","Hőszigetelés, energetikai korszerűsítés","Általános karbantartás és javítás"],
  },
  {
    key: "garden",
    title: "Kert és Külső területek",
    subtitle: "Rendezett környezet egész évben",
    items: ["Fűnyírás, fűkaszálás, zöldterület-kezelés","Sövényvágás, bozótirtás","Magasnyomású tisztítás (térkő, tető)","Teljes udvar- és kertgondozás"],
  },
];

const DEFAULT_PRICING = [
  {
    title: "Egyszeri karbantartás",
    badge: "",
    price: "Egyedi árajánlat",
    desc: "Egyszeri alkalom, ha valami elromlott vagy rendbe kell tenni a nyaralót.",
    items: ["Helyszíni felmérés díjmentes","Javítás, festés, takarítás","Kertrendezés, fűnyírás","Magasnyomású tisztítás","Rugalmas időpont egyeztetés"],
    cta: "Árajánlatot kérek",
    highlight: false,
  },
  {
    title: "Éves karbantartás",
    badge: "Legjobb választás",
    price: "Éves szerződéssel",
    desc: "Folyamatos gondoskodás egész évben — Ön egy hívással intéz el mindent.",
    items: ["Minden egyszeri szolgáltatás","Negyedéves kiszállás","Szezonális előkészítés","Elsőbbségi időpontfoglalás","Kedvezményes árak","Írásos állapotjelentés"],
    cta: "Kapcsolatba lépek",
    highlight: true,
  },
  {
    title: "Felújítási munkák",
    badge: "",
    price: "Projekt alapú",
    desc: "Nagyobb felújítás, hőszigetelés, homlokzat vagy teljes belső munkák.",
    items: ["Ingyenes helyszíni felmérés","Részletes költségvetés","Minőségi anyagok","Garanciális kivitelezés","Fotódokumentáció"],
    cta: "Ajánlatot kérek",
    highlight: false,
  },
];

const DEFAULT_GAL = [
  { key:"gallery_0", label:"Vakolás és kőművesmunka", tag:"Felújítás", large:true },
  { key:"gallery_1", label:"Festés és belső munkák",   tag:"Belső",    large:false },
  { key:"gallery_2", label:"Magasnyomású tisztítás",   tag:"Külső",    large:false },
  { key:"gallery_3", label:"Sövényvágás",              tag:"Kert",     large:false },
  { key:"gallery_4", label:"Karbantartott nyaraló",    tag:"Referencia",large:false },
  { key:"gallery_5", label:"Zöldterület-kezelés",      tag:"Kert",     large:false },
];

const DEFAULT_IMAGES = {
  hero: "https://images.unsplash.com/photo-1745761320791-5ae142edee8c?w=800",
  gallery_0: "https://images.unsplash.com/photo-1704005445445-2747074be8ac?w=900",
  gallery_1: "https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=600",
  gallery_2: "/tisztitas.jpg",
  gallery_3: "https://images.unsplash.com/photo-1637531347055-4fa8aa80c111?w=600",
  gallery_4: "https://images.unsplash.com/photo-1746458258536-b9ee5db20a73?w=600",
  gallery_5: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=600",
  construction: "https://images.unsplash.com/photo-1593786267440-550458cc882a?w=800",
  garden: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=800",
};

// ═══════════════════════════════════════════════════════════════
// SUPABASE
// ═══════════════════════════════════════════════════════════════
const SB_URL = process.env.REACT_APP_SUPABASE_URL;
const SB_KEY = process.env.REACT_APP_SUPABASE_KEY;

async function sbGet(table) {
  const res = await fetch(`${SB_URL}/rest/v1/${table}?select=*`, {
    headers: { apikey: SB_KEY, Authorization: `Bearer ${SB_KEY}` }
  });
  return res.json();
}

async function sbUpsert(table, data) {
  await fetch(`${SB_URL}/rest/v1/${table}`, {
    method: "POST",
    headers: {
      apikey: SB_KEY,
      Authorization: `Bearer ${SB_KEY}`,
      "Content-Type": "application/json",
      Prefer: "resolution=merge-duplicates",
    },
    body: JSON.stringify(data),
  });
}

async function loadFromDB() {
  try {
    const [contentRows, listRows, imageRows] = await Promise.all([
      sbGet("km_content"),
      sbGet("km_lists"),
      sbGet("km_images"),
    ]);

    const content = { ...DEFAULT_CONTENT };
    (contentRows || []).forEach(r => { content[r.id] = r.value; });

    const lists = {};
    (listRows || []).forEach(r => { lists[r.id] = r.value; });

    const images = { ...DEFAULT_IMAGES };
    (imageRows || []).forEach(r => { images[r.id] = r.url; });

    return {
      content,
      pillars:  lists.pillars  || DEFAULT_PILLARS,
      svc:      lists.svc      || DEFAULT_SVC,
      pricing:  lists.pricing  || DEFAULT_PRICING,
      gallery:  lists.gallery  || DEFAULT_GAL,
      images,
    };
  } catch(e) {
    return { content: DEFAULT_CONTENT, pillars: DEFAULT_PILLARS, svc: DEFAULT_SVC, pricing: DEFAULT_PRICING, gallery: DEFAULT_GAL, images: DEFAULT_IMAGES };
  }
}

async function saveToDB(data) {
  const contentRows = Object.entries(data.content).map(([id, value]) => ({ id, value }));
  const listRows = [
    { id: "pillars", value: data.pillars },
    { id: "svc",     value: data.svc },
    { id: "pricing", value: data.pricing },
    { id: "gallery", value: data.gallery },
  ];
  const imageRows = Object.entries(data.images).map(([id, url]) => ({ id, url }));

  await Promise.all([
    sbUpsert("km_content", contentRows),
    sbUpsert("km_lists",   listRows),
    sbUpsert("km_images",  imageRows),
  ]);
}

// ═══════════════════════════════════════════════════════════════
// CSS
// ═══════════════════════════════════════════════════════════════
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Inter:wght@400;500;600;700;800&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; overflow-x: hidden; }
  body { font-family: 'Inter', sans-serif; background: #F5F5F0; color: #1A2421; -webkit-font-smoothing: antialiased; overflow-x: hidden; max-width: 100vw; }
  .fd { font-family: 'DM Serif Display', Georgia, serif; }

  @keyframes rise { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
  .rise { animation: rise 0.7s cubic-bezier(.22,1,.36,1) both; }
  .d1{animation-delay:.1s}.d2{animation-delay:.2s}.d3{animation-delay:.35s}.d4{animation-delay:.5s}

  @keyframes marquee { from{transform:translateX(0)} to{transform:translateX(-50%)} }
  .marquee { animation: marquee 45s linear infinite; will-change:transform; display:flex; width:max-content; }

  @keyframes saved-pop { 0%{opacity:0;transform:scale(.8)} 20%{opacity:1;transform:scale(1.05)} 100%{opacity:1;transform:scale(1)} }
  .saved-pop { animation: saved-pop .4s ease both; }

  ::-webkit-scrollbar{width:5px} ::-webkit-scrollbar-thumb{background:#C85A32;border-radius:3px}

  .nav-wrap{position:fixed;top:0;left:0;right:0;z-index:100;transition:all .3s}
  .nav-wrap.scrolled{background:rgba(245,245,240,.94);backdrop-filter:blur(20px);border-bottom:1px solid #E0E0D8}
  .nav-inner{max-width:1280px;margin:0 auto;padding:16px 48px;display:flex;align-items:center;justify-content:space-between}
  .nav-links{display:flex;gap:36px}
  .nav-link{font-size:13px;font-weight:700;letter-spacing:.06em;color:#4A5550;text-decoration:none;transition:color .2s}
  .nav-link:hover{color:#C85A32}
  .nav-cta{display:flex;align-items:center;gap:8px;padding:10px 20px;background:#1A2421;color:#F5F5F0;font-size:13px;font-weight:700;text-decoration:none;border-radius:2px;transition:background .3s;white-space:nowrap}
  .nav-cta:hover{background:#C85A32}
  .nav-ham{display:none;background:none;border:none;cursor:pointer;color:#1A2421;padding:6px}
  .mob-menu{display:none;background:#F5F5F0;border-top:1px solid #E0E0D8;padding:20px 24px;flex-direction:column;gap:0}
  .mob-menu.open{display:flex}
  .mob-link{display:block;padding:14px 0;font-size:16px;font-weight:700;color:#1A2421;text-decoration:none;border-bottom:1px solid #E0E0D8}
  .mob-link:hover{color:#C85A32}
  .mob-cta{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:16px;padding:14px;background:#C85A32;color:#F5F5F0;font-weight:700;text-decoration:none;border-radius:2px;font-size:15px}

  .sec-inner{max-width:1280px;margin:0 auto;padding:0 48px}
  .eyebrow{display:flex;align-items:center;gap:12px;margin-bottom:20px}
  .eyebrow-line{display:inline-block;width:40px;height:1px;background:#C85A32;flex-shrink:0}
  .eyebrow-text{font-size:11px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:#C85A32}
  .sec-header{display:grid;grid-template-columns:7fr 5fr;gap:32px;align-items:end}
  .sec-h2{font-size:clamp(1.8rem,4vw,3.4rem);font-weight:700;line-height:1.06;letter-spacing:-.03em;color:#1A2421}
  .sec-desc{font-size:17px;color:#4A5550;line-height:1.75}

  .hero-grid{display:grid;grid-template-columns:7fr 5fr;gap:64px;align-items:center}
  .svc-grid{display:grid;grid-template-columns:1fr 1fr;gap:32px;margin-top:56px}
  .why-hdr{display:grid;grid-template-columns:7fr 5fr;gap:40px;align-items:end;margin-bottom:64px}
  .pillars{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:rgba(245,245,240,.08)}
  .gal-grid{display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:300px 300px;gap:10px;margin-top:48px}
  .price-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:56px}
  .cta-grid{display:grid;grid-template-columns:5fr 7fr;gap:64px;align-items:start}
  .foot-grid{display:grid;grid-template-columns:5fr 3fr 4fr;gap:48px;padding-bottom:40px;border-bottom:1px solid rgba(245,245,240,.1)}

  @media(max-width:768px){
    .nav-inner{padding:14px 20px}
    .nav-links,.nav-cta{display:none!important}
    .nav-ham{display:flex!important}
    .sec-inner{padding:0 20px}
    .sec-header{grid-template-columns:1fr;gap:12px}
    .sec-h2{font-size:clamp(1.6rem,7vw,2.2rem)}
    .sec-desc{font-size:15px}
    .hero-grid{grid-template-columns:1fr;gap:0}
    .hero-img-col{display:none}
    .hero-section{padding-top:100px!important;padding-bottom:60px!important}
    .hero-h1{font-size:clamp(2.2rem,9vw,3rem)!important}
    .svc-grid{grid-template-columns:1fr;gap:20px;margin-top:36px}
    .why-hdr{grid-template-columns:1fr;gap:16px;margin-bottom:36px}
    .pillars{grid-template-columns:1fr 1fr}
    .gal-grid{grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:8px}
    .gal-large{grid-column:span 2!important;grid-row:span 1!important;height:200px!important}
    .gal-small{height:140px!important}
    .price-grid{grid-template-columns:1fr;gap:16px}
    .cta-grid{grid-template-columns:1fr;gap:32px}
    .foot-grid{grid-template-columns:1fr;gap:28px}
    .why-section,.gal-section,.svc-section,.price-section,.cta-section{padding:60px 0!important}
  }

  /* ── ADMIN ── */
  .adm{min-height:100vh;background:#0D1411;color:#F5F5F0;font-family:'Inter',sans-serif}
  .adm-nav{background:#1A2421;border-bottom:1px solid rgba(255,255,255,.08);padding:0 24px;display:flex;align-items:center;justify-content:space-between;height:58px;position:sticky;top:0;z-index:50}
  .adm-logo{font-family:'DM Serif Display',serif;font-size:17px;font-weight:700;color:#F5F5F0}
  .adm-logo em{color:#C85A32;font-style:normal}
  .adm-body{display:grid;grid-template-columns:220px 1fr;min-height:calc(100vh - 58px)}
  .adm-sidebar{background:#141C19;border-right:1px solid rgba(255,255,255,.06);padding:20px 12px;display:flex;flex-direction:column;gap:4px}
  .adm-sitem{display:flex;align-items:center;gap:10px;padding:10px 14px;border-radius:6px;font-size:13px;font-weight:600;color:rgba(245,245,240,.5);cursor:pointer;border:none;background:none;text-align:left;width:100%;transition:all .2s}
  .adm-sitem:hover{background:rgba(255,255,255,.05);color:#F5F5F0}
  .adm-sitem.active{background:rgba(200,90,50,.15);color:#C85A32}
  .adm-sitem svg{flex-shrink:0}
  .adm-main{padding:28px 32px;overflow-y:auto}
  .adm-title{font-size:20px;font-weight:800;color:#F5F5F0;margin-bottom:6px}
  .adm-sub{font-size:13px;color:rgba(245,245,240,.4);margin-bottom:24px}
  .adm-card{background:#1A2421;border:1px solid rgba(255,255,255,.07);border-radius:10px;padding:24px;margin-bottom:16px}
  .adm-card-title{font-size:12px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#C85A32;margin-bottom:18px;display:flex;align-items:center;gap:8px}
  .adm-field{margin-bottom:14px}
  .adm-label{display:block;font-size:11px;font-weight:700;color:rgba(245,245,240,.4);text-transform:uppercase;letter-spacing:.08em;margin-bottom:5px}
  .adm-input{width:100%;padding:9px 12px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:5px;color:#F5F5F0;font-size:14px;font-family:'Inter',sans-serif;transition:border .2s;outline:none}
  .adm-input:focus{border-color:#C85A32;background:rgba(255,255,255,.07)}
  .adm-textarea{min-height:80px;resize:vertical;line-height:1.6}
  .adm-row{display:grid;grid-template-columns:1fr 1fr;gap:12px}
  .adm-list-item{display:flex;align-items:center;gap:8px;margin-bottom:8px}
  .adm-list-item input{flex:1}
  .adm-icon-btn{background:none;border:none;cursor:pointer;padding:6px;border-radius:4px;display:flex;align-items:center;justify-content:center;transition:all .2s}
  .adm-icon-btn:hover{background:rgba(255,255,255,.08)}
  .adm-icon-btn.danger:hover{background:rgba(200,90,50,.15);color:#C85A32}
  .adm-add-btn{display:flex;align-items:center;gap:6px;padding:7px 14px;background:rgba(200,90,50,.12);border:1px dashed rgba(200,90,50,.3);border-radius:5px;color:#C85A32;font-size:12px;font-weight:700;cursor:pointer;transition:all .2s;width:100%;justify-content:center;margin-top:4px}
  .adm-add-btn:hover{background:rgba(200,90,50,.2)}
  .adm-save-bar{position:sticky;bottom:0;background:#0D1411;border-top:1px solid rgba(255,255,255,.07);padding:14px 32px;display:flex;align-items:center;gap:14px;margin:0 -32px -28px}
  .adm-save-btn{display:flex;align-items:center;gap:8px;padding:11px 28px;background:#C85A32;color:#F5F5F0;border:none;border-radius:6px;font-weight:700;font-size:14px;cursor:pointer;transition:background .2s}
  .adm-save-btn:hover{background:#A64826}
  .adm-saved-badge{display:flex;align-items:center;gap:6px;padding:8px 16px;background:rgba(76,175,80,.15);border:1px solid rgba(76,175,80,.3);border-radius:6px;color:#4CAF50;font-size:13px;font-weight:700}
  .adm-img-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:14px}
  .adm-img-card{background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;overflow:hidden;transition:border .2s}
  .adm-img-card:hover{border-color:rgba(200,90,50,.4)}
  .adm-img-thumb{width:100%;height:120px;object-fit:cover;display:block}
  .adm-img-empty{width:100%;height:120px;background:rgba(255,255,255,.04);display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.15)}
  .adm-img-info{padding:10px 12px}
  .adm-img-name{font-size:11px;font-weight:700;color:rgba(245,245,240,.4);text-transform:uppercase;letter-spacing:.06em;margin-bottom:7px}
  .adm-upload-btn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;padding:7px;background:rgba(200,90,50,.1);border:1px solid rgba(200,90,50,.25);border-radius:4px;color:#C85A32;font-size:11px;font-weight:700;cursor:pointer;transition:all .2s}
  .adm-upload-btn:hover{background:rgba(200,90,50,.2)}
  .adm-highlight-toggle{display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:rgba(245,245,240,.6);user-select:none}
  .adm-toggle{width:36px;height:20px;background:rgba(255,255,255,.1);border-radius:10px;position:relative;transition:background .2s;flex-shrink:0}
  .adm-toggle.on{background:#C85A32}
  .adm-toggle::after{content:'';position:absolute;top:2px;left:2px;width:16px;height:16px;background:#fff;border-radius:50%;transition:transform .2s}
  .adm-toggle.on::after{transform:translateX(16px)}
  .adm-pricing-card{background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:18px;margin-bottom:12px}
  .adm-pricing-card.highlighted{border-color:rgba(200,90,50,.4);background:rgba(200,90,50,.05)}

  /* login */
  .login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0D1411}
  .login-box{background:#1A2421;border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:44px 36px;width:100%;max-width:380px}
  .login-logo{font-family:'DM Serif Display',serif;font-size:22px;font-weight:700;color:#F5F5F0;text-align:center;margin-bottom:8px}
  .login-logo em{color:#C85A32;font-style:normal}
  .login-sub{text-align:center;font-size:13px;color:rgba(245,245,240,.35);margin-bottom:28px}
  .login-err{background:rgba(200,90,50,.12);border:1px solid rgba(200,90,50,.3);color:#C85A32;padding:10px 14px;border-radius:5px;font-size:13px;margin-bottom:14px;text-align:center}
  .login-btn{width:100%;padding:13px;background:#C85A32;color:#F5F5F0;border:none;border-radius:5px;font-weight:700;font-size:15px;cursor:pointer;margin-top:6px;transition:background .2s}
  .login-btn:hover{background:#A64826}

  @media(max-width:640px){
    .adm-body{grid-template-columns:1fr}
    .adm-sidebar{flex-direction:row;overflow-x:auto;padding:8px;border-right:none;border-bottom:1px solid rgba(255,255,255,.06)}
    .adm-sitem{flex-direction:column;font-size:10px;gap:4px;padding:8px 10px;white-space:nowrap}
    .adm-main{padding:16px}
    .adm-save-bar{margin:0 -16px -16px;padding:12px 16px}
    .adm-row{grid-template-columns:1fr}
  }

  @keyframes cookie-slide { from{transform:translateY(100%);opacity:0} to{transform:translateY(0);opacity:1} }
  .cookie-bar{position:fixed;bottom:0;left:0;right:0;z-index:200;background:#1A2421;border-top:2px solid #C85A32;padding:14px 24px;display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;animation:cookie-slide .4s cubic-bezier(.22,1,.36,1) both}
  .cookie-text{font-size:13px;color:rgba(245,245,240,.65);line-height:1.6;max-width:640px}
  .cookie-text a{color:#C85A32;text-decoration:underline}
  .cookie-btn{flex-shrink:0;padding:9px 22px;background:#C85A32;color:#F5F5F0;border:none;border-radius:4px;font-size:13px;font-weight:700;cursor:pointer;transition:background .2s;white-space:nowrap}
  .cookie-btn:hover{background:#A64826}
`;

// ═══════════════════════════════════════════════════════════════
// SITE COMPONENTS
// ═══════════════════════════════════════════════════════════════
function Navbar({ content }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const links = [
    { label:"Szolgáltatások", href:"#szolgaltatasok" },
    { label:"Áraink",         href:"#araink" },
    { label:"Rólunk",         href:"#rolunk" },
    { label:"Galéria",        href:"#galeria" },
    { label:"Kapcsolat",      href:"#kapcsolat" },
  ];
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <header className={`nav-wrap${scrolled?" scrolled":""}`}>
      <div className="nav-inner">
        <a href="#top" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
          <img src="/logo.png" alt="Kiss-Master" style={{height:46,width:"auto"}} />
        </a>
        <nav className="nav-links">
          {links.map(l => <a key={l.href} href={l.href} className="nav-link">{l.label}</a>)}
        </nav>
        <a href={`tel:${content.phone.replace(/\s/g,"")}`} className="nav-cta">
          <IPhone size={14} sw={2}/> {content.phone}
        </a>
        <button className="nav-ham" onClick={() => setOpen(o=>!o)}>
          {open ? <IClose size={24}/> : <IMenu size={24}/>}
        </button>
      </div>
      <div className={`mob-menu${open?" open":""}`}>
        {links.map(l => <a key={l.href} href={l.href} className="mob-link" onClick={()=>setOpen(false)}>{l.label}</a>)}
        <a href={`tel:${content.phone.replace(/\s/g,"")}`} className="mob-cta"><IPhone size={17} sw={2}/> {content.phone}</a>
      </div>
    </header>
  );
}

function Hero({ content, images }) {
  return (
    <section id="top" className="hero-section" style={{position:"relative",paddingTop:160,paddingBottom:100,overflow:"hidden",background:"linear-gradient(160deg,#F5F5F0 60%,#EDE9E0 100%)"}}>
      <div className="sec-inner" style={{position:"relative",zIndex:1}}>
        <div className="hero-grid">
          <div>
            <div className="rise eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text">Nyaralók · Hétvégi házak · Üdülők</span></div>
            <h1 className="rise d1 fd hero-h1" style={{fontSize:"clamp(2.8rem,5vw,4.5rem)",fontWeight:700,lineHeight:1.04,letterSpacing:"-.03em",color:"#1A2421"}}>
              {content.hero_title_1}<br/>
              <span style={{color:"#C85A32"}}>{content.hero_title_2}</span><br/>
              {content.hero_title_3}
            </h1>
            <p className="rise d2" style={{marginTop:28,fontSize:17,color:"#4A5550",lineHeight:1.75,maxWidth:540}}>{content.hero_desc}</p>
            <div className="rise d3" style={{marginTop:36,display:"flex",gap:14,flexWrap:"wrap"}}>
              <HeroBtn href={`tel:${content.phone.replace(/\s/g,"")}`} primary><IPhone size={17} sw={2}/> Ingyenes felmérés <IArrowR size={17} sw={2}/></HeroBtn>
              <HeroBtn href="#szolgaltatasok">Szolgáltatásaink</HeroBtn>
            </div>
            <div className="rise d4" style={{marginTop:40,display:"flex",flexWrap:"wrap",gap:"14px 36px",fontSize:13}}>
              {[[<IPin size={14} style={{color:"#C85A32"}}/>,content.region],["•",content.experience],["•","Ingyenes árajánlat"]].map(([ic,txt],i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{color:"#C85A32",display:"flex"}}>{ic}</span>
                  <span style={{fontWeight:600,color:"#1A2421"}}>{txt}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-img-col" style={{position:"relative"}}>
            <span style={{position:"absolute",top:-16,left:-16,width:72,height:72,borderTop:"2px solid #C85A32",borderLeft:"2px solid #C85A32"}}/>
            <span style={{position:"absolute",bottom:-16,right:-16,width:72,height:72,borderBottom:"2px solid #C85A32",borderRight:"2px solid #C85A32"}}/>
            <img src={images.hero} alt="Nyaraló" style={{width:"100%",height:520,objectFit:"cover",borderRadius:2,display:"block"}}/>
            <div style={{position:"absolute",bottom:20,left:20,right:20,background:"rgba(245,245,240,.95)",backdropFilter:"blur(12px)",padding:"14px 20px",border:"1px solid #E0E0D8"}}>
              <div style={{fontSize:10,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"#C85A32",marginBottom:6}}>Kapcsolattartó</div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
                <span className="fd" style={{fontSize:19,fontWeight:700,color:"#1A2421",whiteSpace:"nowrap"}}>{content.contact_name}</span>
                <a href={`tel:${content.phone.replace(/\s/g,"")}`} style={{fontSize:14,fontWeight:700,color:"#1A2421",textDecoration:"underline",textDecorationColor:"rgba(200,90,50,.4)",textUnderlineOffset:4,whiteSpace:"nowrap"}}>{content.phone}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroBtn({href,children,primary}){
  const [h,setH]=useState(false);
  return <a href={href} onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{display:"inline-flex",alignItems:"center",gap:10,padding:"15px 28px",borderRadius:2,fontWeight:700,fontSize:15,textDecoration:"none",transition:"all .3s",...(primary?{background:h?"#A64826":"#C85A32",color:"#F5F5F0",transform:h?"translateY(-2px)":"none",boxShadow:"0 8px 30px -12px rgba(200,90,50,.55)"}:{background:"transparent",color:h?"#C85A32":"#1A2421",border:`1px solid ${h?"#C85A32":"rgba(26,36,33,.2)"}`})}}>{children}</a>;
}

function TaglineBanner() {
  const items=["Nyaralók karbantartása","Hétvégi házak felújítása","Kertgondozás","Magasnyomású tisztítás","Hőszigetelés","Ingyenes felmérés","Békés megye"];
  const seq=Array.from({length:8}).flatMap(()=>items);
  return (
    <section style={{background:"#1A2421",padding:"13px 0",overflow:"hidden",borderTop:"1px solid rgba(245,245,240,.06)",borderBottom:"1px solid rgba(245,245,240,.06)"}}>
      <div className="marquee">
        {seq.map((w,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:24,padding:"0 28px"}}>
            <span style={{fontSize:11,fontWeight:700,letterSpacing:".14em",textTransform:"uppercase",whiteSpace:"nowrap",color:"rgba(245,245,240,.5)"}}>{w}</span>
            <span style={{width:4,height:4,transform:"rotate(45deg)",background:"#C85A32",display:"inline-block",flexShrink:0}}/>
          </div>
        ))}
      </div>
    </section>
  );
}

const SVC_ICONS = [IMtn,ITruck,IPaint,ILayers,IThermo,IWrench,ISprout,IScissors,IDrop,ITree];

function SvcCard({ d, si, images }) {
  const [h,setH]=useState(false);
  return (
    <article onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{background:"#F5F5F0",border:`1px solid ${h?"#C85A32":"#E0E0D8"}`,borderRadius:2,overflow:"hidden",display:"flex",flexDirection:"column",transition:"border-color .4s"}}>
      <div style={{position:"relative",height:260,overflow:"hidden"}}>
        <img src={images[d.key]} alt={d.title} loading="lazy" style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform 1.2s ease-out",transform:h?"scale(1.05)":"scale(1)"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(26,36,33,.75),transparent 60%)"}}/>
        <div style={{position:"absolute",bottom:18,left:22,right:22}}>
          <div style={{fontSize:10,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"rgba(245,245,240,.8)",marginBottom:6}}>{d.subtitle}</div>
          <h3 className="fd" style={{fontSize:"clamp(1.3rem,2.5vw,1.7rem)",fontWeight:700,color:"#F5F5F0",lineHeight:1.15}}>{d.title}</h3>
        </div>
      </div>
      <ul style={{padding:"20px 28px",display:"flex",flexDirection:"column",gap:4,listStyle:"none"}}>
        {d.items.map((label,idx)=>{
          const I=SVC_ICONS[(si*6+idx)%SVC_ICONS.length];
          return (
            <li key={idx} style={{display:"flex",alignItems:"flex-start",gap:14,padding:"9px 0",borderBottom:idx<d.items.length-1?"1px dashed #E0E0D8":"none"}}>
              <span style={{flexShrink:0,width:34,height:34,display:"grid",placeItems:"center",background:h?"rgba(200,90,50,.1)":"rgba(26,36,33,.05)",transition:"background .4s"}}>
                <I size={15} style={{color:"#C85A32"}}/>
              </span>
              <div style={{display:"flex",alignItems:"baseline",gap:10,paddingTop:4}}>
                <span style={{fontSize:11,fontWeight:700,color:"rgba(200,90,50,.6)"}}>{String(idx+1).padStart(2,"0")}</span>
                <span style={{fontSize:15,fontWeight:500,color:"#1A2421"}}>{label}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </article>
  );
}

function Services({ svc, images }) {
  return (
    <section id="szolgaltatasok" className="svc-section" style={{padding:"88px 0"}}>
      <div className="sec-inner">
        <div className="sec-header">
          <div>
            <div className="eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text">Szolgáltatásaink</span></div>
            <h2 className="fd sec-h2">Mindent megoldunk — <span style={{color:"#C85A32"}}>a tetőtől a kertkapuig.</span></h2>
          </div>
          <p className="sec-desc">Két fő szakterület, egy megbízható csapat. Akár felújításra, akár folyamatos karbantartásra van szüksége — egy hívással elintézhető.</p>
        </div>
        <div className="svc-grid">
          {svc.map((d,si) => <SvcCard key={d.key} d={d} si={si} images={images}/>)}
        </div>
      </div>
    </section>
  );
}

function PriceCard({ p, phone }) {
  const [h,setH]=useState(false);
  return (
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{background:p.highlight?"#1A2421":"#F5F5F0",border:`2px solid ${p.highlight?"#C85A32":h?"#C85A32":"#E0E0D8"}`,borderRadius:4,padding:"32px 28px",display:"flex",flexDirection:"column",position:"relative",transition:"border-color .3s"}}>
      {p.badge && <div style={{position:"absolute",top:-13,left:"50%",transform:"translateX(-50%)",background:"#C85A32",color:"#F5F5F0",fontSize:11,fontWeight:800,letterSpacing:".1em",textTransform:"uppercase",padding:"4px 14px",borderRadius:20,whiteSpace:"nowrap"}}>{p.badge}</div>}
      <div className="fd" style={{fontSize:20,fontWeight:700,color:p.highlight?"#F5F5F0":"#1A2421",marginBottom:8}}>{p.title}</div>
      <div style={{fontSize:13,fontWeight:800,letterSpacing:".06em",textTransform:"uppercase",color:"#C85A32",marginBottom:14}}>{p.price}</div>
      <p style={{fontSize:14,color:p.highlight?"rgba(245,245,240,.65)":"#4A5550",lineHeight:1.7,marginBottom:24}}>{p.desc}</p>
      <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:10,flex:1}}>
        {p.items.map((item,j)=>(
          <li key={j} style={{display:"flex",alignItems:"flex-start",gap:10,fontSize:14,color:p.highlight?"rgba(245,245,240,.8)":"#1A2421"}}>
            <ICheck size={15} style={{color:"#C85A32",flexShrink:0,marginTop:2}} sw={2.5}/>{item}
          </li>
        ))}
      </ul>
      <a href={`tel:${phone.replace(/\s/g,"")}`} style={{marginTop:28,display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"13px",background:p.highlight?"#C85A32":"transparent",border:`1.5px solid ${p.highlight?"#C85A32":"#1A2421"}`,color:p.highlight?"#F5F5F0":"#1A2421",borderRadius:3,fontWeight:700,fontSize:14,textDecoration:"none",transition:"all .3s"}}
        onMouseEnter={e=>{e.currentTarget.style.background="#C85A32";e.currentTarget.style.borderColor="#C85A32";e.currentTarget.style.color="#F5F5F0"}}
        onMouseLeave={e=>{e.currentTarget.style.background=p.highlight?"#C85A32":"transparent";e.currentTarget.style.borderColor=p.highlight?"#C85A32":"#1A2421";e.currentTarget.style.color=p.highlight?"#F5F5F0":"#1A2421"}}
      ><IPhone size={14} sw={2}/> {p.cta}</a>
    </div>
  );
}

function Pricing({ pricing, content }) {
  return (
    <section id="araink" className="price-section" style={{padding:"88px 0",background:"#EAEAE4"}}>
      <div className="sec-inner">
        <div className="sec-header">
          <div>
            <div className="eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text">Áraink</span></div>
            <h2 className="fd sec-h2">Átlátható árak,<br/><span style={{color:"#C85A32"}}>meglepetések nélkül.</span></h2>
          </div>
          <p className="sec-desc">Minden munkára ingyenes helyszíni felmérést végzünk és írásos árajánlatot adunk. Rejtett költségek nincsenek.</p>
        </div>
        <div className="price-grid">
          {pricing.map((p,i)=><PriceCard key={i} p={p} phone={content.phone}/>)}
        </div>
      </div>
    </section>
  );
}

function PillarCard({ title, desc, num }) {
  const [h,setH]=useState(false);
  const Icons=[IHammer,IShield,IClock,ISearch];
  const I=Icons[num%Icons.length];
  return (
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{background:h?"#22302C":"#1A2421",padding:"36px 30px",transition:"background .5s"}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:28}}>
        <span style={{color:"#C85A32",transform:h?"scale(1.1)":"scale(1)",transition:"transform .5s",display:"inline-block"}}><I size={34} sw={1.5}/></span>
        <span className="fd" style={{fontSize:13,color:"rgba(245,245,240,.22)",fontWeight:700}}>0{num+1}</span>
      </div>
      <h3 className="fd" style={{fontSize:19,fontWeight:700,lineHeight:1.25,marginBottom:10}}>{title}</h3>
      <p style={{fontSize:14,color:"rgba(245,245,240,.55)",lineHeight:1.7}}>{desc}</p>
    </div>
  );
}

function WhyChoose({ content, pillars }) {
  return (
    <section id="rolunk" className="why-section" style={{background:"#1A2421",color:"#F5F5F0",padding:"88px 0"}}>
      <div className="sec-inner">
        <div className="why-hdr">
          <div>
            <div className="eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text" style={{color:"#C85A32"}}>Miért minket válasszon?</span></div>
            <h2 className="fd" style={{fontSize:"clamp(2rem,4vw,3.6rem)",fontWeight:700,lineHeight:1.06,letterSpacing:"-.03em"}}>
              {content.why_title_1}<br/><span style={{color:"#C85A32"}}>{content.why_title_2}</span>
            </h2>
          </div>
          <p style={{fontSize:17,color:"rgba(245,245,240,.65)",lineHeight:1.75}}>{content.why_desc}</p>
        </div>
        <div className="pillars">
          {pillars.map(({title,desc},i)=>(
            <PillarCard key={i} title={title} desc={desc} num={i}/>
          ))}
        </div>
      </div>
    </section>
  );
}

function GalItem({ m, images }) {
  const [h,setH]=useState(false);
  return (
    <figure onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      className={m.large?"gal-large":"gal-small"}
      style={{position:"relative",overflow:"hidden",borderRadius:2,background:"#1A2421",gridColumn:m.large?"span 2":"span 1",gridRow:m.large?"span 2":"span 1",margin:0,height:m.large?undefined:300}}>
      <img src={images[m.key]} alt={m.label} loading="lazy" style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform 1.5s ease-out",transform:h?"scale(1.07)":"scale(1)"}}/>
      <figcaption style={{position:"absolute",bottom:0,left:0,right:0,padding:"16px 18px",background:"linear-gradient(to top,rgba(26,36,33,.9) 0%,transparent 100%)"}}>
        <div style={{fontSize:9,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"#C85A32",marginBottom:5}}>{m.tag}</div>
        <div className="fd" style={{fontSize:14,fontWeight:700,color:"#F5F5F0"}}>{m.label}</div>
      </figcaption>
    </figure>
  );
}

function Gallery({ gallery, images }) {
  return (
    <section id="galeria" className="gal-section" style={{padding:"88px 0",background:"#EAEAE4"}}>
      <div className="sec-inner">
        <div className="sec-header">
          <div>
            <div className="eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text">Galéria</span></div>
            <h2 className="fd sec-h2">Munka közben.</h2>
          </div>
          <p className="sec-desc">Minden képkocka mögött pontos kivitelezés, tiszta munkaterület és elégedett ügyfél áll.</p>
        </div>
        <div className="gal-grid">
          {gallery.map((m)=><GalItem key={m.key} m={m} images={images}/>)}
        </div>
      </div>
    </section>
  );
}

function ContactRow({ I, label, value, href, hl }) {
  const [h,setH]=useState(false);
  const Tag=href?"a":"div";
  return (
    <Tag href={href} onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{display:"flex",alignItems:"center",gap:24,padding:"20px 28px",border:`1px solid ${h?"#C85A32":"#E0E0D8"}`,borderRadius:2,background:h?"#fff":"#F5F5F0",textDecoration:"none",transition:"all .3s",cursor:href?"pointer":"default"}}>
      <span style={{flexShrink:0,width:48,height:48,display:"grid",placeItems:"center",borderRadius:2,background:hl?"#C85A32":"rgba(26,36,33,.06)",color:hl?"#F5F5F0":"#C85A32"}}><I size={20} sw={1.8}/></span>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:10,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"rgba(200,90,50,.8)",marginBottom:3}}>{label}</div>
        <div className="fd" style={{fontSize:20,fontWeight:700,color:"#1A2421",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{value}</div>
      </div>
      {href && <IArrowUR size={16} style={{color:h?"#C85A32":"rgba(26,36,33,.3)",transition:"all .3s",transform:h?"rotate(45deg)":"none",flexShrink:0}}/>}
    </Tag>
  );
}

function Contact({ content }) {
  const [h,setH]=useState(false);
  return (
    <section id="kapcsolat" className="cta-section" style={{padding:"88px 0"}}>
      <div className="sec-inner">
        <div className="cta-grid">
          <div>
            <div className="eyebrow"><span className="eyebrow-line"/><span className="eyebrow-text">Kapcsolat</span></div>
            <h2 className="fd" style={{fontSize:"clamp(1.8rem,3.5vw,3rem)",fontWeight:700,lineHeight:1.06,letterSpacing:"-.03em",color:"#1A2421"}}>
              Kérjen ingyenes <span style={{color:"#C85A32"}}>felmérést</span> még ma.
            </h2>
            <p style={{marginTop:24,fontSize:16,color:"#4A5550",lineHeight:1.75}}>Telefonon vagy e-mailben keressenek minket az ingyenes helyszíni felméréshez és egyedi árajánlatkéréshez.</p>
            <div style={{marginTop:28,display:"inline-flex",alignItems:"center",gap:8,padding:"8px 14px",border:"1px solid rgba(26,36,33,.15)",borderRadius:2}}>
              <IPin size={14} style={{color:"#C85A32"}}/><span style={{fontSize:13,fontWeight:600,color:"#1A2421"}}>{content.region}</span>
            </div>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <ContactRow I={IUser}  label="Kapcsolattartó" value={content.contact_name} href={null} hl={false}/>
            <ContactRow I={IPhone} label="Telefon"         value={content.phone}        href={`tel:${content.phone.replace(/\s/g,"")}`} hl={true}/>
            <ContactRow I={IMail}  label="E-mail"          value={content.email}        href={`mailto:${content.email}`} hl={false}/>
            <a href={`tel:${content.phone.replace(/\s/g,"")}`} onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
              style={{marginTop:4,display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,padding:"24px 28px",background:h?"#C85A32":"#1A2421",color:"#F5F5F0",borderRadius:2,textDecoration:"none",transition:"background .5s"}}>
              <span className="fd" style={{fontSize:"clamp(1rem,2vw,1.3rem)",fontWeight:700,letterSpacing:"-.02em"}}>Hívjon most az ingyenes felméréshez</span>
              <IArrowUR size={24} style={{flexShrink:0,transform:h?"rotate(45deg)":"none",transition:"transform .5s"}}/>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer({ content }) {
  const [h1,setH1]=useState(false);
  const [h2,setH2]=useState(false);
  return (
    <footer style={{background:"#1A2421",color:"rgba(245,245,240,.7)",padding:"64px 0 0"}}>
      <div className="sec-inner">
        <div className="foot-grid">
          <div>
            <div style={{marginBottom:18}}><img src="/logo.png" alt="Kiss-Master" style={{height:46,width:"auto",display:"block",filter:"brightness(0) invert(1)"}}/></div>
            <p style={{fontSize:14,lineHeight:1.8,maxWidth:320}}>Nyaralók, hétvégi házak és üdülők teljes körű karbantartása és felújítása. Ön pihen — mi gondoskodunk róla.</p>
          </div>
          <div>
            <div style={{fontSize:10,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"#C85A32",marginBottom:14}}>Szolgáltatások</div>
            <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:8,fontSize:13}}>
              {["Építőipar és felújítás","Hőszigetelés, homlokzat","Kert és külterület","Magasnyomású tisztítás"].map(s=><li key={s}>{s}</li>)}
            </ul>
          </div>
          <div>
            <div style={{fontSize:10,fontWeight:800,letterSpacing:".18em",textTransform:"uppercase",color:"#C85A32",marginBottom:14}}>Kapcsolat</div>
            <ul style={{listStyle:"none",display:"flex",flexDirection:"column",gap:10,fontSize:13}}>
              <li>{content.contact_name}</li>
              <li><a href={`tel:${content.phone.replace(/\s/g,"")}`} onMouseEnter={()=>setH1(true)} onMouseLeave={()=>setH1(false)} style={{display:"inline-flex",alignItems:"center",gap:6,color:h1?"#C85A32":"inherit",textDecoration:"none",transition:"color .2s"}}><IPhone size={13}/> {content.phone}</a></li>
              <li><a href={`mailto:${content.email}`} onMouseEnter={()=>setH2(true)} onMouseLeave={()=>setH2(false)} style={{display:"inline-flex",alignItems:"center",gap:6,color:h2?"#C85A32":"inherit",textDecoration:"none",transition:"color .2s"}}><IMail size={13}/> {content.email}</a></li>
              <li>{content.region}</li>
            </ul>
          </div>
        </div>
        <div style={{padding:"24px 0",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12,fontSize:11,color:"rgba(245,245,240,.35)"}}>
          <span>© {new Date().getFullYear()} Kiss-Master Kft. — Minden jog fenntartva.</span>
          <div style={{display:"flex",alignItems:"center",gap:20,flexWrap:"wrap"}}>
            <a href="#adatvedelem" style={{color:"rgba(245,245,240,.5)",textDecoration:"none",fontSize:11}}>Adatvédelmi tájékoztató</a>
            <span style={{fontWeight:800,letterSpacing:".12em",textTransform:"uppercase",color:"#C85A32",fontSize:10}}>Érték · Biztonság · Megbízhatóság</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

// ═══════════════════════════════════════════════════════════════
// ADMIN LOGIN
// ═══════════════════════════════════════════════════════════════
const ADMIN_PW = process.env.REACT_APP_ADMIN_PASSWORD;

function AdminLogin({ onLogin }) {
  const [pw,setPw]=useState("");
  const [err,setErr]=useState(false);
  const submit=()=>{ if(pw===ADMIN_PW){onLogin();setErr(false);}else setErr(true); };
  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo">KISS-MASTER<em>.</em></div>
        <div className="login-sub">Admin belépés</div>
        {err && <div className="login-err">Helytelen jelszó. Próbálja újra.</div>}
        <div className="adm-field">
          <label className="adm-label">Jelszó</label>
          <input type="password" className="adm-input" value={pw} onChange={e=>setPw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&submit()} placeholder="••••••••••••"/>
        </div>
        <button className="login-btn" onClick={submit}><ILock size={14} sw={2} style={{display:"inline",marginRight:8,verticalAlign:"middle"}}/>Belépés</button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// ADMIN PANEL
// ═══════════════════════════════════════════════════════════════
const IMG_LABELS = {
  hero:"Hero főkép", construction:"Építőipar kártya", garden:"Kert kártya",
  gallery_0:"Galéria 1 (nagy)", gallery_1:"Galéria 2", gallery_2:"Galéria 3",
  gallery_3:"Galéria 4", gallery_4:"Galéria 5", gallery_5:"Galéria 6",
};

function ImgCard({ imgKey, label, src, onUpload }) {
  const ref=useRef();
  return (
    <div className="adm-img-card">
      {src ? <img src={src} alt={label} className="adm-img-thumb"/> : <div className="adm-img-empty"><IImg size={28}/></div>}
      <div className="adm-img-info">
        <div className="adm-img-name">{label}</div>
        <div className="adm-upload-btn" onClick={()=>ref.current.click()}>
          <IImg size={12}/> Feltöltés
        </div>
        <input ref={ref} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&onUpload(imgKey,e.target.files[0])}/>
      </div>
    </div>
  );
}

function AdminPanel({ onLogout, onPreview }) {
  const [tab,setTab]=useState("contact");
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [saving,setSaving]=useState(false);
  const [saved,setSaved]=useState(false);

  useEffect(()=>{
    loadFromDB().then(d=>{ setData(d); setLoading(false); });
  },[]);

  const persist = async (newData) => {
    setData(newData);
    setSaving(true);
    await saveToDB(newData);
    setSaving(false);
    setSaved(true);
    setTimeout(()=>setSaved(false),2500);
  };

  if(loading) return (
    <div className="adm" style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh"}}>
      <div style={{textAlign:"center"}}>
        <div style={{width:40,height:40,border:"3px solid rgba(255,255,255,.1)",borderTopColor:"#C85A32",borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 16px"}}/>
        <div style={{color:"rgba(245,245,240,.4)",fontSize:13}}>Adatok betöltése...</div>
      </div>
    </div>
  );

  const setContent = (field,val) => persist({...data, content:{...data.content,[field]:val}});
  const setPillars = (p) => persist({...data, pillars:p});
  const setSvc     = (s) => persist({...data, svc:s});
  const setPricing = (p) => persist({...data, pricing:p});
  const setGallery = (g) => persist({...data, gallery:g});

  const handleImgUpload = (key,file) => {
    const reader=new FileReader();
    reader.onload=e=>persist({...data, images:{...data.images,[key]:e.target.result}});
    reader.readAsDataURL(file);
  };

  const TABS=[
    {id:"contact", label:"Kapcsolat",      icon:<IPhone size={15}/>},
    {id:"hero",    label:"Hero",            icon:<IImg size={15}/>},
    {id:"svc",     label:"Szolgáltatások",  icon:<IWrench size={15}/>},
    {id:"pricing", label:"Áraink",          icon:<ICheck size={15}/>},
    {id:"why",     label:"Rólunk",          icon:<IShield size={15}/>},
    {id:"gallery", label:"Galéria",         icon:<IImg size={15}/>},
    {id:"images",  label:"Képek",           icon:<IImg size={15}/>},
  ];

  return (
    <div className="adm">
      <nav className="adm-nav">
        <div className="adm-logo">KISS-MASTER<em>.</em> <span style={{fontSize:12,color:"rgba(245,245,240,.3)",fontFamily:"Inter,sans-serif",fontWeight:600,marginLeft:8}}>Admin</span></div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {saving && <div style={{fontSize:13,color:"rgba(245,245,240,.4)",display:"flex",alignItems:"center",gap:6}}><div style={{width:14,height:14,border:"2px solid rgba(255,255,255,.1)",borderTopColor:"#C85A32",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/> Mentés...</div>}
          {saved && !saving && <div className="adm-saved-badge saved-pop"><ICheck size={14} sw={2.5}/> Mentve!</div>}
          <button className="adm-preview-btn" onClick={onPreview} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 16px",background:"rgba(245,245,240,.07)",border:"1px solid rgba(245,245,240,.12)",borderRadius:5,color:"#F5F5F0",fontSize:13,fontWeight:700,cursor:"pointer"}}>
            <IEye size={15}/> Előnézet
          </button>
          <button onClick={onLogout} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 14px",background:"transparent",border:"1px solid rgba(245,245,240,.12)",borderRadius:5,color:"rgba(245,245,240,.5)",fontSize:13,cursor:"pointer"}}>
            <ILogout size={14}/> Kilépés
          </button>
        </div>
      </nav>

      <div className="adm-body">
        {/* SIDEBAR */}
        <aside className="adm-sidebar">
          {TABS.map(t=>(
            <button key={t.id} className={`adm-sitem${tab===t.id?" active":""}`} onClick={()=>setTab(t.id)}>
              {t.icon}{t.label}
            </button>
          ))}
        </aside>

        {/* MAIN */}
        <main className="adm-main">

          {/* ── CONTACT ── */}
          {tab==="contact" && <>
            <div className="adm-title">Kapcsolati adatok</div>
            <div className="adm-sub">Ezek az adatok megjelennek a navbarban, a hero szekcióban, a kapcsolat oldalon és a footerben.</div>
            <div className="adm-card">
              <div className="adm-card-title"><IUser size={14}/> Személyes adatok</div>
              {[["Kapcsolattartó neve","contact_name"],["Telefonszám","phone"],["E-mail cím","email"],["Munkaterület","region"],["Tapasztalat","experience"]].map(([lbl,field])=>(
                <div className="adm-field" key={field}>
                  <label className="adm-label">{lbl}</label>
                  <input className="adm-input" value={data.content[field]||""} onChange={e=>setContent(field,e.target.value)}/>
                </div>
              ))}
            </div>
          </>}

          {/* ── HERO ── */}
          {tab==="hero" && <>
            <div className="adm-title">Hero szekció</div>
            <div className="adm-sub">A főoldal első szekciójának szövegei.</div>
            <div className="adm-card">
              <div className="adm-card-title">Főcím (3 sor)</div>
              <div className="adm-row">
                <div className="adm-field">
                  <label className="adm-label">1. sor</label>
                  <input className="adm-input" value={data.content.hero_title_1||""} onChange={e=>setContent("hero_title_1",e.target.value)}/>
                </div>
                <div className="adm-field">
                  <label className="adm-label">3. sor</label>
                  <input className="adm-input" value={data.content.hero_title_3||""} onChange={e=>setContent("hero_title_3",e.target.value)}/>
                </div>
              </div>
              <div className="adm-field">
                <label className="adm-label">2. sor (narancs színű)</label>
                <input className="adm-input" value={data.content.hero_title_2||""} onChange={e=>setContent("hero_title_2",e.target.value)}/>
              </div>
              <div className="adm-field">
                <label className="adm-label">Leíró szöveg</label>
                <textarea className="adm-input adm-textarea" value={data.content.hero_desc||""} onChange={e=>setContent("hero_desc",e.target.value)}/>
              </div>
            </div>
          </>}

          {/* ── SERVICES ── */}
          {tab==="svc" && <>
            <div className="adm-title">Szolgáltatások</div>
            <div className="adm-sub">A két szolgáltatás kártya tartalma. Elemeket hozzáadhatsz vagy törölhetsz.</div>
            {data.svc.map((s,si)=>(
              <div key={si} className="adm-card">
                <div className="adm-card-title"><IWrench size={14}/> {s.title}</div>
                <div className="adm-row">
                  <div className="adm-field">
                    <label className="adm-label">Cím</label>
                    <input className="adm-input" value={s.title} onChange={e=>{const ns=[...data.svc];ns[si]={...s,title:e.target.value};setSvc(ns);}}/>
                  </div>
                  <div className="adm-field">
                    <label className="adm-label">Alcím</label>
                    <input className="adm-input" value={s.subtitle} onChange={e=>{const ns=[...data.svc];ns[si]={...s,subtitle:e.target.value};setSvc(ns);}}/>
                  </div>
                </div>
                <label className="adm-label" style={{marginBottom:8,display:"block"}}>Lista elemek</label>
                {s.items.map((item,ii)=>(
                  <div key={ii} className="adm-list-item">
                    <input className="adm-input" value={item} onChange={e=>{const ns=[...data.svc];ns[si]={...s,items:s.items.map((x,j)=>j===ii?e.target.value:x)};setSvc(ns);}}/>
                    <button className="adm-icon-btn danger" onClick={()=>{const ns=[...data.svc];ns[si]={...s,items:s.items.filter((_,j)=>j!==ii)};setSvc(ns);}}>
                      <ITrash size={14} style={{color:"rgba(245,245,240,.4)"}}/>
                    </button>
                  </div>
                ))}
                <button className="adm-add-btn" onClick={()=>{const ns=[...data.svc];ns[si]={...s,items:[...s.items,"Új elem"]};setSvc(ns);}}>
                  <IPlus size={13}/> Elem hozzáadása
                </button>
              </div>
            ))}
          </>}

          {/* ── PRICING ── */}
          {tab==="pricing" && <>
            <div className="adm-title">Árak szekció</div>
            <div className="adm-sub">A három ár kártya tartalma. Minden mező szerkeszthető.</div>
            {data.pricing.map((p,pi)=>(
              <div key={pi} className={`adm-pricing-card${p.highlight?" highlighted":""}`}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
                  <div className="adm-card-title" style={{margin:0}}>Kártya {pi+1}</div>
                  <label className="adm-highlight-toggle">
                    <div className={`adm-toggle${p.highlight?" on":""}`} onClick={()=>{const np=[...data.pricing];np[pi]={...p,highlight:!p.highlight};setPricing(np);}}/>
                    Kiemelt
                  </label>
                </div>
                <div className="adm-row">
                  <div className="adm-field">
                    <label className="adm-label">Cím</label>
                    <input className="adm-input" value={p.title} onChange={e=>{const np=[...data.pricing];np[pi]={...p,title:e.target.value};setPricing(np);}}/>
                  </div>
                  <div className="adm-field">
                    <label className="adm-label">Ár/felirat</label>
                    <input className="adm-input" value={p.price} onChange={e=>{const np=[...data.pricing];np[pi]={...p,price:e.target.value};setPricing(np);}}/>
                  </div>
                </div>
                <div className="adm-row">
                  <div className="adm-field">
                    <label className="adm-label">Badge szöveg (opcionális)</label>
                    <input className="adm-input" value={p.badge||""} onChange={e=>{const np=[...data.pricing];np[pi]={...p,badge:e.target.value};setPricing(np);}}/>
                  </div>
                  <div className="adm-field">
                    <label className="adm-label">Gomb szöveg</label>
                    <input className="adm-input" value={p.cta} onChange={e=>{const np=[...data.pricing];np[pi]={...p,cta:e.target.value};setPricing(np);}}/>
                  </div>
                </div>
                <div className="adm-field">
                  <label className="adm-label">Leírás</label>
                  <textarea className="adm-input adm-textarea" style={{minHeight:60}} value={p.desc} onChange={e=>{const np=[...data.pricing];np[pi]={...p,desc:e.target.value};setPricing(np);}}/>
                </div>
                <label className="adm-label" style={{marginBottom:8,display:"block"}}>Lista elemek</label>
                {p.items.map((item,ii)=>(
                  <div key={ii} className="adm-list-item">
                    <input className="adm-input" value={item} onChange={e=>{const np=[...data.pricing];np[pi]={...p,items:p.items.map((x,j)=>j===ii?e.target.value:x)};setPricing(np);}}/>
                    <button className="adm-icon-btn danger" onClick={()=>{const np=[...data.pricing];np[pi]={...p,items:p.items.filter((_,j)=>j!==ii)};setPricing(np);}}>
                      <ITrash size={14} style={{color:"rgba(245,245,240,.4)"}}/>
                    </button>
                  </div>
                ))}
                <button className="adm-add-btn" onClick={()=>{const np=[...data.pricing];np[pi]={...p,items:[...p.items,"Új elem"]};setPricing(np);}}>
                  <IPlus size={13}/> Elem hozzáadása
                </button>
              </div>
            ))}
          </>}

          {/* ── WHY ── */}
          {tab==="why" && <>
            <div className="adm-title">Rólunk szekció</div>
            <div className="adm-sub">A sötét hátteres "Miért minket válasszon?" szekció.</div>
            <div className="adm-card">
              <div className="adm-card-title">Főcím</div>
              <div className="adm-row">
                <div className="adm-field">
                  <label className="adm-label">1. sor</label>
                  <input className="adm-input" value={data.content.why_title_1||""} onChange={e=>setContent("why_title_1",e.target.value)}/>
                </div>
                <div className="adm-field">
                  <label className="adm-label">2. sor (narancs)</label>
                  <input className="adm-input" value={data.content.why_title_2||""} onChange={e=>setContent("why_title_2",e.target.value)}/>
                </div>
              </div>
              <div className="adm-field">
                <label className="adm-label">Leíró szöveg</label>
                <textarea className="adm-input adm-textarea" value={data.content.why_desc||""} onChange={e=>setContent("why_desc",e.target.value)}/>
              </div>
            </div>
            <div className="adm-card">
              <div className="adm-card-title">4 pillér kártya</div>
              {data.pillars.map((p,i)=>(
                <div key={i} style={{padding:"16px 0",borderBottom:i<data.pillars.length-1?"1px solid rgba(255,255,255,.06)":"none"}}>
                  <div style={{fontSize:11,fontWeight:700,color:"rgba(245,245,240,.3)",letterSpacing:".1em",textTransform:"uppercase",marginBottom:10}}>0{i+1}</div>
                  <div className="adm-row">
                    <div className="adm-field">
                      <label className="adm-label">Cím</label>
                      <input className="adm-input" value={p.title} onChange={e=>{const np=[...data.pillars];np[i]={...p,title:e.target.value};setPillars(np);}}/>
                    </div>
                    <div className="adm-field">
                      <label className="adm-label">Leírás</label>
                      <input className="adm-input" value={p.desc} onChange={e=>{const np=[...data.pillars];np[i]={...p,desc:e.target.value};setPillars(np);}}/>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>}

          {/* ── GALLERY ── */}
          {tab==="gallery" && <>
            <div className="adm-title">Galéria feliratok</div>
            <div className="adm-sub">A galéria képek feliratai és tag-ei (pl. Kert, Belső, Külső).</div>
            <div className="adm-card">
              {data.gallery.map((g,i)=>(
                <div key={g.key} style={{padding:"14px 0",borderBottom:i<data.gallery.length-1?"1px solid rgba(255,255,255,.06)":"none"}}>
                  <div style={{fontSize:11,fontWeight:700,color:"rgba(245,245,240,.3)",letterSpacing:".1em",textTransform:"uppercase",marginBottom:10}}>Galéria {i+1}{g.large?" (nagy)":""}</div>
                  <div className="adm-row">
                    <div className="adm-field">
                      <label className="adm-label">Felirat</label>
                      <input className="adm-input" value={g.label} onChange={e=>{const ng=[...data.gallery];ng[i]={...g,label:e.target.value};setGallery(ng);}}/>
                    </div>
                    <div className="adm-field">
                      <label className="adm-label">Tag (pl. Kert, Külső)</label>
                      <input className="adm-input" value={g.tag} onChange={e=>{const ng=[...data.gallery];ng[i]={...g,tag:e.target.value};setGallery(ng);}}/>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>}

          {/* ── IMAGES ── */}
          {tab==="images" && <>
            <div className="adm-title">Képek kezelése</div>
            <div className="adm-sub">Kattints a "Feltöltés" gombra és válassz képet a gépedről. A kép azonnal mentődik.</div>
            <div className="adm-card">
              <div className="adm-img-grid">
                {Object.entries(IMG_LABELS).map(([key,label])=>(
                  <ImgCard key={key} imgKey={key} label={label} src={data.images[key]} onUpload={handleImgUpload}/>
                ))}
              </div>
            </div>
          </>}

        </main>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// APP
// ═══════════════════════════════════════════════════════════════
function linkifyLine(line, key) {
  const urlRe = /(https?:\/\/[^\s]+)/g;
  const parts = line.split(urlRe);
  return (
    <p key={key} style={{fontSize:15,color:"#4A5550",lineHeight:1.8,marginBottom:8}}>
      {parts.map((part, i) =>
        /^https?:\/\//.test(part)
          ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{color:"#C85A32",textDecoration:"underline"}}>{part}</a>
          : <span key={i}>{part}</span>
      )}
    </p>
  );
}

function PrivacyPage() {
  return (
    <>
      <style>{CSS}</style>
      <header style={{background:"#1A2421",padding:"16px 48px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="/" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
          <img src="/logo.png" alt="Kiss-Master" style={{height:42,width:"auto",filter:"brightness(0) invert(1)"}}/>
        </a>
        <a href="/" style={{fontSize:13,fontWeight:700,color:"rgba(245,245,240,.6)",textDecoration:"none"}}>← Vissza a főoldalra</a>
      </header>
      <main style={{maxWidth:760,margin:"0 auto",padding:"60px 24px 80px"}}>
        <h1 className="fd" style={{fontSize:"clamp(2rem,4vw,2.8rem)",fontWeight:700,color:"#1A2421",marginBottom:8}}>Adatvédelmi tájékoztató</h1>
        <p style={{fontSize:13,color:"#4A5550",marginBottom:48}}>Utoljára frissítve: {new Date().getFullYear()}. január</p>

        {[
          {
            title: "1. Az Adatkezelő adatai",
            content: "• Név: Kiss-Master Kft.\n• Székhely: 5700 Gyula, Ecsedi utca 38/A\n• Cégjegyzékszám: 04-09-018181\n• Adószám: 33077379-2-04\n• Nyilvántartó bíróság: Békés Vármegyei Cégbíróság\n• Képviselő / Kapcsolattartó: Kiss Márton\n• E-mail: kissmasterkft@gmail.com\n• Telefon: +36 20 542 0090"
          },
          {
            title: "2. Adatfeldolgozók (Közreműködők)",
            content: "Az Adatkezelő a weboldal üzemeltetéséhez az alábbi adatfeldolgozókat (harmadik feleket) veszi igénybe. Az adatfeldolgozók az Adatkezelő utasításai alapján, önálló célú adatkezelést nem végeznek, a rájuk vonatkozó saját adatkezelési tájékoztatójuk az alábbi linkeken érhető el.\n\nTárhely-szolgáltató:\n• Név: Tárhely.Eu Szolgáltató Kft.\n• Székhely: 1144 Budapest, Ormánság utca 4. X. em. 241.\n• E-mail: support@tarhely.eu\n• Végzett tevékenység: A weboldal tárhelyszolgáltatása, szervernaplók (log fájlok) technikai üzemeltetése.\n• Kezelt adatok köre: Látogatói IP-cím, technikai naplóadatok.\n• Adatkezelési tájékoztatójuk: https://tarhely.eu/dokumentumok/adatvedelmi_szabalyzat.pdf\n\nInfrastruktúra és felhőszolgáltató:\n• Név: Supabase Inc.\n• Székhely/Szerver helye: Európai Unió (Frankfurt, Németország)\n• Feladat: A weboldal forráskódjának, statikus tartalmának (szövegek, képek), valamint az adatbázisban tárolt adatoknak a kiszolgálása és tárolása.\n• Kezelt adatok köre: A weboldalon keresztül megadott és tárolt tartalmi, illetve technikai adatok.\n• Adatkezelési tájékoztatójuk: https://supabase.com/privacy\n\nA fenti adatfeldolgozók igénybevételének jogalapja: GDPR 6. cikk (1) bekezdés f) pont, az Adatkezelő jogos érdeke a weboldal biztonságos és folyamatos üzemeltetéséhez."
          },
          {
            title: "3. A kezelt adatok köre, célja és jogalapja",
            content: "A) Technikai adatok és szervernaplók (Log fájlok)\n• Kezelt adatok: A látogató IP-címe, a látogatás időpontja, a böngésző és az operációs rendszer típusa.\n• Az adatkezelés célja: A weboldal biztonságos működésének ellenőrzése, a visszaélések megelőzése és a technikai hibák elhárítása.\n• Az adatkezelés jogalapja: GDPR 6. cikk (1) bekezdés f) pont – az Adatkezelő jogos érdeke (a weboldal információbiztonságának és stabil működésének biztosítása).\n• Időtartam: A szervernaplók automatikusan törlődnek 30 nap elteltével.\n\nB) Működéshez szükséges sütik (Essential Cookies)\n• Süti neve: km_cookie\n• Funkció: Tárolja, hogy a látogató tudomásul vette-e a süti-tájékoztatót.\n• Az adatkezelés célja: Annak elkerülése, hogy a tájékoztató sáv minden egyes aloldal betöltésekor újra megjelenjen.\n• Az adatkezelés jogalapja: GDPR 6. cikk (1) bekezdés f) pont – az Adatkezelő jogos érdeke (felhasználói élmény biztosítása és jogszabályi megfelelőség igazolása).\n• Időtartam: A látogatástól számított 1 év."
          },
          {
            title: "4. Az érintettek (Látogatók) jogai",
            content: "Önt a GDPR alapján az alábbi jogok illetik meg, amelyeket a kissmasterkft@gmail.com e-mail címre küldött nyilatkozattal gyakorolhat:\n\n• Hozzáférés joga: Tájékoztatást kérhet arról, hogy kezelünk-e Önre vonatkozó személyes adatot.\n• Törléshez való jog („elfeledtetés”): Kérheti adatai törlését, ha a jogalap megszűnt.\n• Korlátozás joga: Kérheti az adatkezelés korlátozását (például az adatok pontosságának vitatása esetén).\n• Tiltakozáshoz való jog: Tiltakozhat a jogos érdeken alapuló adatkezelés (technikai naplózás) ellen."
          },
          {
            title: "5. Jogorvoslati lehetőségek",
            content: "Ha úgy érzi, hogy az Adatkezelő megsértette a magánélethez való jogát, kérjük, először vegye fel velünk a kapcsolatot a fenti elérhetőségeken a probléma gyors békés rendezése érdekében.\n\nAmennyiben ez nem vezet eredményre, az alábbi szervekhez fordulhat:\n\nHatósági panasz: Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)\n• Cím: 1055 Budapest, Falk Miksa utca 9-11.\n• Levelezési cím: 1363 Budapest, Pf. 9.\n• E-mail: ugyfelszolgalat@naih.hu\n• Web: www.naih.hu\n\nBírósági jogorvoslat: Jogosult a lakóhelye vagy tartózkodási helye szerinti vármegyei törvényszékhez fordulni."
          },
          {
            title: "6. Alkalmazott jogszabályok",
            content: "• A GDPR (Az Európai Parlament és a Tanács (EU) 2016/679 rendelete)\n• Az Infotörvény (2011. évi CXII. törvény az információs önrendelkezési jogról és az információszabadságról)\n• Az Elker tv. (2001. évi CVIII. törvény az elektronikus kereskedelmi szolgáltatások egyes kérdéseiről)"
          },
        ].map(({title, content}) => (
          <div key={title} style={{marginBottom:40,paddingBottom:40,borderBottom:"1px solid #E0E0D8"}}>
            <h2 className="fd" style={{fontSize:22,fontWeight:700,color:"#1A2421",marginBottom:16}}>{title}</h2>
            {content.split("\n").map((line,i) => (
              line ? linkifyLine(line, i) : <br key={i}/>
            ))}
          </div>
        ))}
      </main>
      <footer style={{background:"#1A2421",padding:"24px 48px",textAlign:"center",fontSize:12,color:"rgba(245,245,240,.35)"}}>
        © {new Date().getFullYear()} Kiss-Master Kft. — Minden jog fenntartva.
      </footer>
    </>
  );
}

function CookieBanner() {
  const [visible, setVisible] = useState(!localStorage.getItem("km_cookie"));
  if(!visible) return null;
  return (
    <div className="cookie-bar">
      <p className="cookie-text">
        Ez a weboldal sütiket használ az alapvető működéshez.{" "}
        <a href="#adatvedelem">Adatvédelmi tájékoztató</a>
      </p>
      <button className="cookie-btn" onClick={()=>{ localStorage.setItem("km_cookie","1"); setVisible(false); }}>
        Elfogadom
      </button>
    </div>
  );
}

export default function App() {
  const [page,setPage]=useState("site");
  const [loggedIn,setLoggedIn]=useState(false);
  const [siteData,setSiteData]=useState(null);
  const [loading,setLoading]=useState(true);
  const firstLoad = useRef(true);

  const fetchData = async (showLoading = false) => {
    if(showLoading) setLoading(true);
    const data = await loadFromDB();
    setSiteData(data);
    setLoading(false);
    firstLoad.current = false;
  };

  useEffect(()=>{ fetchData(true); },[]);

  useEffect(()=>{
    let link = document.querySelector("link[rel~='icon']");
    if(!link){
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.type = "image/png";
    link.href = "/favicon.png";
  },[]);

  useEffect(()=>{
    const check=()=>{
      if(window.location.hash==="#admin"){
        setPage(loggedIn?"admin":"login");
      } else if(window.location.hash==="#adatvedelem"){
        setPage("privacy");
      } else {
        setPage("site");
        fetchData(false);
      }
    };
    check();
    window.addEventListener("hashchange",check);
    return ()=>window.removeEventListener("hashchange",check);
  },[loggedIn]);

  if(loading) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#F5F5F0"}}>
      <div style={{textAlign:"center"}}>
        <img src="/logo.png" alt="Kiss-Master" style={{height:56,marginBottom:24,opacity:.6}}/>
        <div style={{width:40,height:40,border:"3px solid #E0E0D8",borderTopColor:"#C85A32",borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto"}}/>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );

  if(page==="login") return <AdminLogin onLogin={()=>{setLoggedIn(true);setPage("admin");}}/>;
  if(page==="privacy") return <PrivacyPage/>;
  if(page==="admin") return (
    <AdminPanel
      onLogout={()=>{setLoggedIn(false);window.location.hash="";}}
      onPreview={()=>{ window.location.hash=""; setTimeout(()=>fetchData(false), 100); }}
    />
  );

  const {content,pillars,svc,pricing,gallery,images}=siteData;

  return (
    <>
      <style>{CSS}</style>
      <Navbar content={content}/>
      <main>
        <Hero content={content} images={images}/>
        <TaglineBanner/>
        <Services svc={svc} images={images}/>
        <Pricing pricing={pricing} content={content}/>
        <WhyChoose content={content} pillars={pillars}/>
        <Gallery gallery={gallery} images={images}/>
        <Contact content={content}/>
      </main>
      <Footer content={content}/>
      <CookieBanner/>
      <a href="#admin" style={{position:"fixed",bottom:0,right:0,width:20,height:20,opacity:0,zIndex:999}}/>
    </>
  );
}
